import { Box, StatusLabel } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface ValidatedProps {
  validated: boolean
}

export const Validated = ({ validated }: ValidatedProps) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s6" width="s140">
        <StatusLabel type={validated ? 'positive' : 'neutral'}>
          {validated
            ? i18n.t('finance.invoices.list.status.validated')
            : i18n.t('finance.invoices.list.status.not_validated')}
        </StatusLabel>
      </Box>
    </Box>
  )
}
